<template>
  <div id="home">
    <div class="home-content content">
      <div class="setting-home">
        <!--管理员控制分发首页按钮-->
        <div style="margin-right: 8px">
          <span class="s-h-text">开启分发首页</span>
          <el-switch
            v-model="isOpen"
            :active-value="2"
            :inactive-value="1"
            active-color="#5a2df5"
            inactive-color="#cccccc"
          >
          </el-switch>
          <!--
             active-color="#44BB66"
            inactive-color="#cccccc"
          -->
        </div>
        <el-button type="primary" class="save" @click.stop="openLogoDrawer"
          >首页配置</el-button
        >
        <el-button
          type="primary"
          class="save"
          @click="getUserInfo"
          style="margin-right: 10px"
          >发布</el-button
        >
      </div>
      <div class="hc-top clear">
        <banner ref="bannerT" />
        <art ref="artT" />
      </div>
      <div class="hc-icon clear">
        <icon ref="iconT" />
      </div>
      <div class="hc-title">
        <template-content ref="tempT" />
      </div>
    </div>
    <!--过期弹出框-->
    <expireTeamDialog />

    <drawer
      class="home-logo-setting"
      :drawerStatus.sync="drawerStatus"
      @close="close"
    >
      <template slot="title">
        <div class="draw-title">
          <h3>首页基础配置</h3>
          <p>建议上传LOGO尺寸: 232*90, 透明底png格式</p>
        </div>
      </template>
      <template slot="content">
        <div class="logo-upload-box">
          <el-form :rules="rules">
            <el-form-item label="顶部logo">
              <el-upload
                :http-request="uploadImage"
                list-type="picture-card"
                class="logo-upload clear"
                :show-file-list="false"
              >
                <img
                  v-if="logoForm.logo"
                  :src="logoForm.logo"
                  class="avatar"
                  width="232"
                  height="88"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div class="upload-hover" v-if="logoForm.logo">
                  <p>替换</p>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="企业名称">
              <el-input
                type="text"
                placeholder="请输入企业名称"
                v-model.trim="logoForm.name"
                @focus="focusTeamName"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </drawer>
  </div>
</template>

<script>
import Art from "./art/art.vue";
import Banner from "./banner/banner.vue";
import Icon from "./icon/icon.vue";
import TemplateContent from "./templateContent/templateContent.vue";
import { HomeSetting, Login } from "@/config/axios/new_api";
import drawer from "@/components/common/drawer.vue";
import axios from 'axios'
export default {
  name: "Home",
  components: { Banner, Art, Icon, TemplateContent, drawer },
  data() {
    return {
      bannerContent: [],
      artContent: [],
      iconContent: [],
      templateContent: [],
      isOpen: 1, // 如果为0
      logoForm: {},
      drawerStatus: false,
    };
  },
  computed: {
    loginInfo() {
      return this.$store.getters.loginInfo;
    },
  },
  created() {
    // 如果当前过期  返回企业模板列表界面
    this.expireHandle();
    this.isOpen = this.loginInfo.is_open;
    this.logoForm = {
      logo: this.loginInfo.current_team_logo,
      name: this.loginInfo.current_team_name,
    };
  },
  watch: {
    "logoForm.name": function (newVal) {
      this.logoForm.name = newVal.replace(/\s*/g, "");
    },
  },
  methods: {
    async save(e) {
      this.buttonBlur(e);
      this.$refs.bannerT.submit();
      this.$refs.artT.submit();
      this.$refs.iconT.submit();
      this.$refs.tempT.submit();
      if (
        !this.$refs.bannerT.errorStatus &&
        !this.$refs.artT.errorStatus &&
        !this.$refs.iconT.errorStatus &&
        !this.$refs.tempT.errorStatus
      ) {
        let bannerData = {
          type: 1,
          data: setData(this.$refs.bannerT.bannerList, 1),
        };
        let artData = {
          type: 2,
          data: setData(this.$refs.artT.list, 2),
        };
        let iconData = {
          type: 3,
          data: setData(this.$refs.iconT.list, 3),
        };
        let tempData = {
          type: 4,
          data: setData(this.$refs.tempT.templateList, 4),
        };

        // HomeSetting.setting(bannerData);
        // HomeSetting.setting(artData);
        // HomeSetting.setting(iconData);
        // HomeSetting.setting(tempData);
        Promise.all([
          HomeSetting.configSetting(bannerData),
          HomeSetting.configSetting(artData),
          HomeSetting.configSetting(iconData),
          HomeSetting.templateSetting(tempData), // type=4单独调用接口
          HomeSetting.basicSetting({
            ...this.logoForm,
            is_open: this.isOpen,
          }),
        ]).then((res) => {
          let status = res.map((item) => item.status);
          let newStatus = status.every((status) => status);
          if (newStatus) {
            this.$message.success("保存成功");
            let info = Object.assign({}, this.loginInfo, {
              is_open: this.isOpen,
            });
            this.$router.push({ name: "Home" });
            this.$store.commit("loginInfo", info);
          } else {
            if (res.status_code !== 40010) {
              let errorInfo = res
                .map((item) => item.error)
                .filter((item) => item);
              if (errorInfo.length) {
                let str = "";
                for (let i = 0; i < errorInfo.length; i++) {
                  str += `<p style="line-height: 20px;">${errorInfo[i]}</p>`;
                }
                // this.$message.error({
                //   dangerouslyUseHTMLString: true,
                //   message: str,
                // });
                if (res[0].status === 0) {
                  this.$refs.bannerT.errorStatus = true;
                }
                if (res[1].status === 0) {
                  this.$refs.artT.errorStatus = true;
                }
                if (res[2].status === 0) {
                  this.$refs.iconT.errorStatus = true;
                }
                if (res[3].status === 0) {
                  this.$refs.tempT.errorStatus = true;
                }
              }
            }
          }
        })
        // HomeSetting.logoSetting({
        //   ...this.logoForm,
        //   is_open: this.isOpen,
        // }).then((res) => {
        //   // 避免页面直接刷新 状态未返回成功， 需要修改vuex
        //   if (res.status === 1) {
        //     let info = Object.assign({}, this.loginInfo, {
        //       is_open: this.isOpen,
        //     });
        //     this.$store.commit("loginInfo", info);
        //   }
        // });
      }

      function setData(arr, type) {
        let saveKey = [
          "path_type",
          "img_name",
          "url",
          "directories_id",
          "template_id",
          "name",
        ];
        if (type === 4) {
          saveKey.push("template_info");
        }
        let data = JSON.parse(JSON.stringify(arr));
        for (let i = 0; i < data.length; i++) {
          if (type === 1) {
            data[i].name = "";
          }
        //   data[i].directories_id += "";
        //   data[i].template_id += "";
          if (type === 4) {
            data[i].template_info = data[i].template_info.map((item, index) => {
              return {
                template_id: item.id,
                order: index,
              };
            });
          }
          for (let b in data[i]) {
            if (!saveKey.includes(b)) {
              delete data[i][b];
            }
          }
        }
        return JSON.stringify(data);
      }
    },
    getUserInfo(e){
      Login.getUserInfo().then((res) => {
        if (res && res.status === 1) {
          this.$store.commit('loginInfo', res.data)
          if(res.data.current_team_id > 0 && res.data.current_team_is_expired == 1 && res.data.current_team_role != 4 ) {
            this.save(e);
          }else {
            this.$message.error('没有操作权限');
            this.$router.push('/template')
          }
        }
      });
    },
    openLogoDrawer() {
      this.drawerStatus = !this.drawerStatus;
    },
    close() {
      this.drawerStatus = false;
    },
    uploadImage(params) {
      let file = params.file;
      var dotIndex = file.name.lastIndexOf(".") + 1;
      var fileTypeStr = file.name.slice(dotIndex);
      let img = ["png", "jpeg", "jpg"];
      if (!img.includes(fileTypeStr)) {
        this.$message({
          message: "请上传png、jpeg、jpg图片",
          center: true,
          customClass: "handle-success",
        });
        return;
      }
      let data = {
        file: file,
        format: fileTypeStr,
        upload_type: 'logo'
      };
      this.staticFunc.qyUploadImg(data, (res) => {
        if (res.status === 1) {
            this.$message.success("上传成功");
            this.logoForm.logo = res.url
        } else {
            this.$message.error(res.message);
        }
      })
    },
  },
};
</script>

<style scoped lang="scss">
.home-content {
  margin: 36px auto 0;
  .hc-top {
    width: 100%;
    height: 304px;
  }
  .setting-home {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 19px;
    .s-h-text {
      margin-right: 10px;
      color: #3c3c43;
      font-size: 14px;
    }
    .save {
      @include wh(100px, 34px);
      margin-left: 16px;
      // background: linear-gradient(180deg, #646470 0%, #3c3c4b 100%);
      // border-radius: 8px;
      padding: 0;
      line-height: 34px;
      text-align: center;
      color: #fff;
      font-weight: 400;
      cursor: pointer;
    }
  }
  .hc-icon {
    margin-top: 6px;
  }
}
</style>
